module.exports = __webpack_public_path__ + "static/favicon-cbbeab4a6ebd56b7865a436c68cd79d4.ico";